import { Map as MapLib } from "maplibre-gl";

export class UserDataManager {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public addUserSources = (_: MapLib) => {
    // do as you wish here - this or something similar should load existing data from index-db (see idb-keyval)
  };
}
